/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../../db.json';
import { ContainerMenuButtons } from '../../../components/Containers';
import ButtonMainContainer from '../../../components/Home/MainContainer/ButtonMainContainer';
import { SearchLinksSystemsAction } from '../../../redux/actions/linksSystem';
import ModalNoAccessToStreaming from '../../../components/ModalNoAccessToStreaming';
import StatusFooter from '../StatusFooter';

export default function NewSystem() {
  const [noAccessToStreaming, setNoAccessToStreaming] = useState(false);
  const themeColors = theme.colors.systems;
  const prefix = '/images/icons/buttons/';
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.userSign);

  useEffect(() => {
    dispatch(SearchLinksSystemsAction());
  }, [dispatch]);

  return (
    <>
      <ContainerMenuButtons>
        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Contabil}
          name="Contábil - CT"
          link="/novo-sistema/contabil"
          linkImg={`${prefix}contabil.png`}
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Fiscal}
          name="Fiscal - FS"
          link="/novo-sistema/fiscal"
          linkImg={`${prefix}coins.svg`}
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Controladoria}
          name="Controladoria - CO"
          link="/novo-sistema/controladoria"
          linkImg={`${prefix}paper.svg`}
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.FinanceiroHospitalar}
          name="Financeiro Hospitalar - FH"
          link="/novo-sistema/financeiro-hospitalar"
          linkImg={`${prefix}financeHospital.svg`}
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.GestaoDePessoas}
          name="Gestão de Pessoas - GP"
          link="/novo-sistema/gestao-de-pessoas"
          linkImg={`${prefix}morePeople.svg`}
        />

        <ButtonMainContainer
          type="link"
          color={themeColors.NS.Colaboracao}
          name="Colaboração - CL"
          link={process.env.REACT_APP_ACCESSKEY_COLLABORATION}
          linkImg={`${prefix}puzzle.svg`}
          target="_blank"
        />

        <ButtonMainContainer
          type="modal"
          color={themeColors.NS.AoVivo}
          name="Ao Vivo - AV"
          yourFunction={() => setNoAccessToStreaming(true)}
          linkImg={`${prefix}openEye.svg`}
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Dashboard}
          name="Dashboard - DS"
          link="/novo-sistema/controladoria/dashboard"
          linkImg={`${prefix}statistic2.svg`}
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Mandala}
          name="Mandala - MA"
          link="/novo-sistema/mandala"
          linkImg={`${prefix}mandala.svg`}
        />
      </ContainerMenuButtons>
      {userInfo && userInfo.accessMode === process.env.REACT_APP_ACCESSKEY_NEW_SYSTEM && <StatusFooter />}

      {noAccessToStreaming && <ModalNoAccessToStreaming setNoAccessToStreaming={setNoAccessToStreaming} />}
    </>
  );
}
